import { Outlet } from 'react-router-dom';
import { PublicSurveyBrandFooter } from './public-survey-brand-footer';
import { PublicSurveyI18nProvider } from './public-survey-i18n-provider';

/** Layout de rota que compartilha i18n entre /surveys/:id e /surveys/confirm. */
export function PublicSurveyRouteLayout() {
  return (
    <PublicSurveyI18nProvider>
      <div className="flex min-h-screen flex-col">
        <div className="flex flex-1 flex-col">
          <Outlet />
        </div>
        <PublicSurveyBrandFooter />
      </div>
    </PublicSurveyI18nProvider>
  );
}
